import React, { useState } from 'react';
import { Trans } from "@lingui/react";
import '../../../styles/about.scss';

const aboutTexts = {
  am: (
    <div>
      <h3 className="modal-subtitle important-text">ՀԱՐԳԵԼԻ՛ ԱՅՑԵԼՈՒ</h3>
      <p>
        «Ավագ» բժշկական կենտրոնը կառուցված է միջազգային չափորոշիչներին համապատասխան, որտեղ հաշվի է առնված նաև ֆիզիկական խնդիրներ ունեցող անձանց կարիքները։
        Կենտրոնում գործում է կենտրոնացված թթվածնային և օդափոխության ներծծման համակարգ, հիվանդասենյակները ևս ապահովված են վերոնշյալ համակարգի կենտրոնացված վահանակներով։
        «Ավագ» բժշկական կենտրոնը ապահոված է էլեկտրականության ինքնաշխատ էլեկտրոէներգիայի արտադրիչ կայանով, որը նույնիսկ տարբեր էլեկտրականության վթարների պարագաներում կապահովի կենտրոնի անխափան աշխատանքը, ինչպես նաև պահուստային ջրային ինքնաշխատ համակարգ՝ տարբեր իրավիճակների համար։
        Կենտրոնում ներդրված է այցելուների հաշվառման և վարման էլեկտրոնային ծրագիր, որը հնարավորություն է տալիս ավելի արագ և արդյունավետ կերպով կազմակերպելու կենտրոնի աշխատանքները։ Համակարգը նպաստում է բուժանձնակազմի աշխատանքին՝ արագ կերպով ապահովելով այցելուի առողջական վիճակի մասին տեղեկատվությունը։
        Ավագ բժշկական կենտրոնում առկա սարքավորումները սահմանված կարգով անցնում են փորձաքննություն։
        «Ավագ» բժշկական կենտրոնը ապահոված է 4 վիրահատարաններով։ Բոլոր վիրահատարաններում առկա են հեպաֆիլտրեր, որոնք ապահովում են օդի առավելագույն մաքրությունը, որը հնարավորություն է տալիս առավել ապահով կերպով իրականացնել տարբեր բարդությունների վիրահատություններ։
        Կենտրոնը ապահովված է ժամանակակից կահավորված և հարմարավետ հիվանդասենյակներով, բազմաֆունկցիոնալ մահճակալներով, հիգիենայի անհրաժեշտ պարագաներով և առանձին սանհանգույցներով։
        «Ավագ» բժշկական կենտրոնում մատուցվում են հիվանդանոցային և արտահիվանդանոցային ծառայություններ՝ գինեկոլոգիական, ընդհանուր վիրաբուժական, անեսթեզիոլոգիական, կլինիկական դեղորայքային, քիթ-կոկորդ-ականջաբանական, անոթային վիրաբուժական, ուրոլոգիական, պրակտոլոգիական, վնասվածքաբանական, օրթոպեդիական, պլաստիկ վերակառուցողական և էսթետիկ վիրաբուժական, ակնաբանական, ներզննական վիրաբուժական, ճառագայթային ախտորոշիչ՝ (ռենտգենաբանական, ուլտրաձայնային), ներզատաբանական, սրտաբանական, լաբորատոր ախտորոշիչ (կլինիկական, կենսաքիմիական, շճաբանական, իմունաբանական), ֆունկցիոնալ ախտորոշիչ, ընտանեկան ստոմատոլոգիական, մաշկաբանական, վեներաբանական։
        «Ավագ» բժշկական կենտրոնը վարում է հիվանդակենտրոն քաղաքականություն։

      </p>
      <p className="important-text"><strong>ՇՆՈՐՀԱԿԱԼՈՒԹՅՈՒՆ</strong>
      </p>
    </div>
  ),
  en: (
    <div>
      <h3 className="modal-subtitle important-text">DEAR VISITOR</h3>
      <p>
        Avag Medical Center is built in accordance with international standards, taking into account the needs of people with physical disabilities.
        The center operates a centralized oxygen and ventilation system, with patient rooms equipped with the appropriate control panels.
        Avag Medical Center is equipped with an automatic power generator ensuring uninterrupted service even in case of power outages, as well as a backup water system for emergency situations.
        An electronic registration and management system has been implemented, allowing for faster and more efficient operations and immediate access to patient health information.
        All medical equipment undergoes regular certification according to standard regulations.
        The center features 4 operating rooms, all equipped with HEPA filters ensuring the highest level of air purity, making it possible to perform surgeries of varying complexity safely.
        Patient rooms are modern, comfortable, equipped with multifunctional beds, hygiene supplies, and private restrooms.
        The center provides both inpatient and outpatient services in gynecology, general surgery, anesthesiology, clinical pharmacology, ENT, vascular surgery, urology, proctology, traumatology, orthopedics, plastic and aesthetic surgery, ophthalmology, endoscopic surgery, radiological diagnostics (X-ray, ultrasound), endocrinology, cardiology, laboratory diagnostics (clinical, biochemical, serological, immunological), functional diagnostics, family dentistry, dermatology, and venereology.
        Avag Medical Center follows a patient-centered approach.

      </p>
      <p className="important-text">
        <strong>THANK YOU</strong>
      </p>
    </div>
  ),
  ru: (
    <div>
      <h3 className="modal-subtitle important-text">УВАЖАЕМЫЙ ПОСЕТИТЕЛЬ!</h3>
      <p>
        Медицинский центр «Аваг» построен по международным стандартам с учетом потребностей людей с ограниченными возможностями.
        В центре действует централизованная система подачи кислорода и вентиляции, а все палаты оборудованы соответствующими панелями.
        Центр оснащен автоматической электростанцией, обеспечивающей бесперебойную работу даже при аварийных отключениях, а также резервной системой подачи воды.
        Внедрена электронная система учета и управления пациентами, способствующая быстрой и эффективной организации работы и обеспечению информации о состоянии здоровья пациента.
        Оборудование проходит регулярную проверку в соответствии с установленными стандартами.
        Центр имеет 4 операционные, оборудованные HEPA-фильтрами для обеспечения максимальной чистоты воздуха, что позволяет безопасно проводить операции различной сложности.
        Палаты оснащены современной мебелью, многофункциональными кроватями, средствами гигиены и отдельными санузлами.
        В центре оказываются как стационарные, так и амбулаторные услуги по направлениям: гинекология, общая хирургия, анестезиология, клиническая фармакология, ЛОР, сосудистая хирургия, урология, проктология, травматология, ортопедия, пластическая и эстетическая хирургия, офтальмология, эндоскопическая хирургия, лучевая диагностика (рентген, УЗИ), эндокринология, кардиология, лабораторная диагностика (клиническая, биохимическая, серологическая, иммунологическая), функциональная диагностика, семейная стоматология, дерматология, венерология.
        «Аваг» придерживается пациенториентированной политики.

      </p>
      <p className="important-text">
        <strong>СПАСИБО</strong>
      </p>
    </div>
  )
};

const About = () => {
  const lang = localStorage.getItem("lang") || "am";
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const [isTextOpen, setIsTextOpen] = useState(false);

  return (
    <div className='component-about'>
      <section className="about">
        {/* Play կոճակ */}
        <div className="video-icon">
          <a
            href="#"
            className="popup-video btn-icon"
            onClick={(e) => {
              e.preventDefault();
              setIsVideoOpen(true);
            }}
            data-animation="bounceIn"
            data-delay=".4s"
            style={{ animationDelay: '.4s' }}
            tabIndex="0"
          >
            <i className="fas fa-play"></i>
          </a>
          {isVideoOpen && (
            <div className="video-overlay" onClick={() => setIsVideoOpen(false)}>
              <div className="video-container" onClick={(e) => e.stopPropagation()}>
                <video
                  src={`/assets/${lang}.${lang === "am" ? "mp4" : "mov"}`}
                  width="800"
                  height="450"
                  controls
                  autoPlay
                />
              </div>
            </div>
          )}
        </div>

        {/* Մեր մասին */}
        <h2>Մեր մասին</h2>
        <p><strong>Մեր </strong> ծառայությունների հիմքում՝ ազնվությունն ու պրոֆեսիոնալիզմն է։</p>
        <p><strong>Մեզ</strong> համար յուրաքանչյուր ոք արժանի է լավագույն բուժսպասարկման։</p>
        <p><strong>Մունք</strong> պարտավորվում ենք անել հնարավորինը՝ չվնասելու, պահպանելու և բարելավելու մարդկանց առողջությունը։</p>
        <p><strong>Մենք</strong> հարգում ենք յուրաքանչյուր մարդու առողջության պահպանման իրավունքը։</p>

        {/* Կարդալ ավելին կոճակ */}
        <button className='ant-btn css-dev-only-do-not-override-mc1tut ant-btn-default ant-btn-color-default ant-btn-variant-outlined booking' onClick={() => setIsTextOpen(true)}><Trans id="more"/></button>
        <p></p>
        {isTextOpen && (
          <div className="modal-overlay" onClick={() => setIsTextOpen(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              {/* <button className="modal-close" onClick={() => setIsTextOpen(false)}>✖</button> */}
              <div className="modal-body">
                {aboutTexts[lang]}
              </div>
            </div>
          </div>
        )}
      </section>

      {/* Լուսանկար */}
      <section>
        <img
          src={"/assets/pic_main.jpg"}
          alt="Description of image"
          className='main-image'
          style={{
            transform: 'scaleX(-1)',
            borderRight: '50px solid #58b84f',
            borderTopRightRadius: '50%',
            borderBottomRightRadius: '50%',
            height: 'auto',
            width: '50%',
            display: 'block',
            marginLeft: 'auto'
          }}
        />
      </section>
    </div>
  );
};

export default About;
